import React, { useMemo, useState } from 'react';
import { X, Calendar, Clock, Info, Check } from 'lucide-react';
interface ScheduleModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (date: string, time: string) => void;
}
export function ScheduleModal({
  isOpen,
  onClose,
  onConfirm
}: ScheduleModalProps) {
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedTime, setSelectedTime] = useState('');
  // Calculate relative time
  const relativeTime = useMemo(() => {
    if (!selectedDate || !selectedTime) return null;
    const scheduledDateTime = new Date(`${selectedDate}T${selectedTime}`);
    const now = new Date();
    const diffMs = scheduledDateTime.getTime() - now.getTime();
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    const diffHours = Math.floor(diffMs % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
    if (diffDays > 0) {
      return `daqui a ${diffDays} dia${diffDays !== 1 ? 's' : ''}`;
    } else if (diffHours > 0) {
      return `daqui a ${diffHours} hora${diffHours !== 1 ? 's' : ''}`;
    } else {
      return 'em breve';
    }
  }, [selectedDate, selectedTime]);
  // Format date for display
  const formattedDateTime = useMemo(() => {
    if (!selectedDate || !selectedTime) return null;
    const [year, month, day] = selectedDate.split('-');
    const [hours, minutes] = selectedTime.split(':');
    const months = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];
    return `${day} de ${months[parseInt(month) - 1]} de ${year} às ${hours}:${minutes}`;
  }, [selectedDate, selectedTime]);
  const handleConfirm = () => {
    if (selectedDate && selectedTime) {
      onConfirm(selectedDate, selectedTime);
      setSelectedDate('');
      setSelectedTime('');
    }
  };
  const handleClose = () => {
    setSelectedDate('');
    setSelectedTime('');
    onClose();
  };
  if (!isOpen) return null;
  const isValid = selectedDate && selectedTime;
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 animate-in fade-in duration-200" data-id="element-96">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-[520px] mx-4 animate-in slide-in-from-bottom-4 duration-300" data-id="element-97">
        <div className="flex items-center justify-between p-6 border-b border-gray-200" data-id="element-98">
          <h2 className="text-xl font-bold text-gray-900" data-id="element-99">
            Agendar Notificação
          </h2>
          <button onClick={handleClose} className="p-1 text-gray-400 hover:text-gray-600 transition-colors" data-id="element-100">
            <X className="w-5 h-5" data-id="element-101" />
          </button>
        </div>

        <div className="p-6 space-y-4" data-id="element-102">
          <div data-id="element-103">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-104">
              Data de Envio
            </label>
            <div className="relative" data-id="element-105">
              <Calendar className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-106" />
              <input type="date" value={selectedDate} onChange={e => setSelectedDate(e.target.value)} min={new Date().toISOString().split('T')[0]} className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8BC4C3] focus:border-transparent" data-id="element-107" />
            </div>
          </div>

          <div data-id="element-108">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-109">
              Horário de Envio
            </label>
            <div className="relative" data-id="element-110">
              <Clock className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-111" />
              <input type="time" value={selectedTime} onChange={e => setSelectedTime(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8BC4C3] focus:border-transparent" data-id="element-112" />
            </div>
          </div>

          {isValid && <div className="bg-gray-50 rounded-lg p-4 border border-gray-200 animate-in fade-in slide-in-from-top-2 duration-200" data-id="element-113">
              <div className="flex items-start gap-3" data-id="element-114">
                <Info className="w-5 h-5 text-[#8BC4C3] flex-shrink-0 mt-0.5" data-id="element-115" />
                <div data-id="element-116">
                  <p className="text-sm text-gray-600 mb-1" data-id="element-117">
                    A notificação será enviada em:
                  </p>
                  <p className="text-sm font-bold text-gray-900" data-id="element-118">
                    {formattedDateTime}
                  </p>
                  <p className="text-xs text-gray-500 mt-1" data-id="element-119">
                    Isso é {relativeTime}
                  </p>
                </div>
              </div>
            </div>}
        </div>

        <div className="flex gap-3 p-6 border-t border-gray-200" data-id="element-120">
          <button onClick={handleClose} className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium" data-id="element-121">
            Cancelar
          </button>
          <button onClick={handleConfirm} disabled={!isValid} className="flex-1 px-4 py-2 bg-[#8BC4C3] text-white rounded-lg hover:bg-[#6BABA9] transition-colors font-medium flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-122">
            <Check className="w-4 h-4" data-id="element-123" />
            Confirmar Agendamento
          </button>
        </div>
      </div>
    </div>;
}